// Internet Explorer 9 and higher
((arr) => {
	arr.forEach((item) => {
		if ( item.hasOwnProperty('remove') ) {
			return;
		}
		Object.defineProperty(item, 'remove', {
			configurable: true,
			enumerable:   true,
			writable:     true,
			value:        function remove() {
				if ( this.parentNode !== null ) {
					this.parentNode.removeChild(this);
				}
			},
		});
	});
})([ Element.prototype, CharacterData.prototype, DocumentType.prototype ]);

// CustomEvent for IE11
(function () {
	if ( typeof window.CustomEvent === 'function' ) return false;
	function CustomEvent(event, params) {
		params = params || { bubbles: false, cancelable: false, detail: undefined };
		var evt = document.createEvent('CustomEvent');
		evt.initCustomEvent(event, params.bubbles, params.cancelable, params.detail);
		return evt;
	}
	CustomEvent.prototype = window.Event.prototype;
	window.CustomEvent = CustomEvent;
})();



// WEBPACK FOOTER //
// ./fe/web-default/src/js/polyfill.js